const tableStyles = {
    headCells: {
      style: {
        fontSize: 16,
        fontWeight: '600',
        color: '#002F53',
        backgroundColor: '#F0F3F5'
      }
    },
    cells: {
        style: {
            fontSize: 16
        }
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgba(0, 47, 83, 0.05)',
            transitionDuration: '0.15s',
            transitionProperty: 'background-color',
            borderBottomColor: 'rgba(0, 0, 0, 0.10)',
            outlineStyle: 'solid',
            outlineWidth: '1px',
            outlineColor: 'rgba(0, 47, 83, 0.02)'
        },
        style: {
            paddingTop: '10px',
            paddingBottom: '10px',
            display: 'flex',
            alignItems: 'flex-start',
        }
    },
    pagination: {
        style: {
            color: 'black',
            fontFamily: 'Montserrat',
            fontSize: 14,
            minHeight: 60
        },
        pageButtonsStyle: {
            borderRadius: '50%',
            height: '40px',
            width: '40px',
            padding: '8px',
            margin: 'px',
            cursor: 'pointer',
            transition: '0.4s',
            color: 'black',
            fill: 'black',
            backgroundColor: 'transparent'
        }
    }
}

export default tableStyles